module.exports = __webpack_public_path__ + "assets/battery-white.4f70c8c6.svg";